var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"text-xs mb-2 block text-left"},[_vm._v(_vm._s(_vm.label))]),_c('input',{ref:"file",staticClass:"block",attrs:{"type":"file"},on:{"change":_vm.onFiles}})])
}
var staticRenderFns = []

export { render, staticRenderFns }